// removed by extract-text-webpack-plugin
module.exports = {"currentClub":"CurrentClub-module__currentClub___vyzyr","pageContainer":"CurrentClub-module__pageContainer___3VUZp","currentClub__text":"CurrentClub-module__currentClub__text___1tLks","currentClub__right":"CurrentClub-module__currentClub__right___228x_","icon":"CurrentClub-module__icon___EWPgW"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/CurrentClub/CurrentClub.module.css
// module id = 628
// module chunks = 0